import axios from 'axios';

import { AdresseIP } from './AdresseIp';

export class CiteService {

    constructor(){
        this.adresse = new AdresseIP()
    }
    
    getAll() {
        
        return axios.get(this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/cite')
                    .then(res => res.data);
    }
    create(newCite) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/cite'
        return axios.post(url,newCite)
                    .then(res => res.data);
    }
    update(idCite ,newCite) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/cite/'
        return axios.put(url+idCite, newCite)
                    .then(res => res.data);
    }
    delete(idCite) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/cite/'
        return axios.patch(url+idCite)
                    .then(res => res.data)
    }
    get(idCite) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/cite/'
        return axios.get(url+idCite)
                    .then(res => res.data)
    }
    getCategorieChambre(idCite) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/cite-categorie/'
        return axios.get(url+idCite)
                    .then(res => res.data)
    }

    getCitesVille(idVille){
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/cite-ville/'
        return axios.get(url+idVille)
                    .then(res => res.data)
    }
    

}